import permissions from '../../permissions'
const CHURN_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.CHURNS.CREATE,
    description: 'Essa permissão dá acesso à listagem e à criação.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.EDIT,
    tag: permissions.CHURNS.UPDATE,
    description: 'Essa permissão dá acesso à listagem e à edição.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.CHURNS.LIST,
    description:
      'Essa permissão dá acesso somente à listagem. Caso outras permissões já concedam esse acesso, esta permissão não é necessária.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.SHOW,
    tag: permissions.CHURNS.SHOW,
    description:
      'Essa permissão dá acesso à listagem e à visualização completa dos dados.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.CHURNS.DESTROY,
    description:
      'Essa permissão dá acesso à listagem e à exclusão. Somente é possível excluir solicitações quando estão na fase de preenchimento.',
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CANCEL,
    tag: permissions.CHURNS.CANCEL,
    description:
      'Essa permissão dá acesso à listagem e ao cancelamento das solicitações que resultaram em churn, para os casos de arrependimento.',
  },
]

export default CHURN_LIST
